import React from 'react';

const ListControls = ({
  searchLabel = 'Search',
  searchPlaceholder,
  searchValue,
  onSearchChange,
  filters = [],
  sortLabel = 'Sort',
  sortValue,
  sortOptions = [],
  onSortChange,
  shownCount,
  totalCount,
  resultLabel,
  chips = [],
  onClear,
}) => {
  return (
    <div className="df-list-controls">
      <div className="df-list-controls-grid">
        <div className="form-group df-list-controls-search">
          <label className="form-label" htmlFor={`${resultLabel}-search`}>
            {searchLabel}
          </label>
          <input
            id={`${resultLabel}-search`}
            type="text"
            className="form-input"
            value={searchValue}
            onChange={(event) => onSearchChange(event.target.value)}
            placeholder={searchPlaceholder}
          />
        </div>

        {filters.map((filter) => (
          <div key={filter.id} className="form-group">
            <label className="form-label" htmlFor={filter.id}>
              {filter.label}
            </label>
            <select
              id={filter.id}
              className="form-select"
              value={filter.value}
              onChange={(event) => filter.onChange(event.target.value)}
            >
              {filter.options.map((option) => (
                <option key={option.value} value={option.value}>
                  {option.label}
                </option>
              ))}
            </select>
          </div>
        ))}

        <div className="form-group">
          <label className="form-label" htmlFor={`${resultLabel}-sort`}>
            {sortLabel}
          </label>
          <select
            id={`${resultLabel}-sort`}
            className="form-select"
            value={sortValue}
            onChange={(event) => onSortChange(event.target.value)}
          >
            {sortOptions.map((option) => (
              <option key={option.value} value={option.value}>
                {option.label}
              </option>
            ))}
          </select>
        </div>
      </div>

      <div className="df-list-controls-footer">
        <div className="df-result-count">
          Showing {shownCount} of {totalCount} {resultLabel}
        </div>
        <button
          type="button"
          className="btn btn-secondary btn-sm"
          onClick={onClear}
          disabled={chips.length === 0}
        >
          Clear filters
        </button>
      </div>

      {chips.length > 0 && (
        <div className="df-chip-row">
          {chips.map((chip) => (
            <button
              key={chip.id}
              type="button"
              className="df-filter-chip"
              onClick={chip.onRemove}
              title={chip.title || `Remove ${chip.label}`}
            >
              {chip.label}
              <span className="df-filter-chip-close" aria-hidden="true">
                x
              </span>
            </button>
          ))}
        </div>
      )}
    </div>
  );
};

export const EmptyFilterState = ({
  title,
  description,
  onClear,
  clearLabel = 'Clear filters',
}) => (
  <div className="df-empty-filter-state">
    <h3 className="df-empty-filter-title">{title}</h3>
    <p className="df-empty-filter-description">{description}</p>
    <button type="button" className="btn btn-secondary btn-sm" onClick={onClear}>
      {clearLabel}
    </button>
  </div>
);

export default ListControls;
